import './ux-signals.scss';

export const UxSignals = ({ id, demo }) => {

    return (

        <div className="hds-mb-20-24"
            data-uxsignals-embed={id}
            data-uxsignals-mode={demo ? 'demo' : ''}>
            </div>

    )
}
